export interface INotificationCard {
  id: string;
  type: ENotificationCardType;
  text: string;
}

// Перечисление типов уведомлений
export enum ENotificationTab {
  ALL = 'all', // Все уведомления
  NEWS = 'news', // Новости
  PERSONAL = 'personal', // Личные уведомления
}

// Перечисление типов уведомлений
export enum ENotificationType {
  SYSTEM = 'system',
  FEEDBACK = 'feedback',
  NEWS = 'news',
  UPDATE = 'update',
}

export enum ENotificationCardType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
}

// Перечисление типов контента в теле уведомления
export enum ENotificationContentType {
  TEXT = 'text',
  SUBTITLE_WITH_LINK = 'subtitle_with_link',
  IMAGE = 'image',
  FEEDBACK_INPUT = 'feedback_input',
}

// Интерфейс для подзаголовка с ссылкой
export interface INotificationSubtitleWithLink {
  subtitle: string;
  linkText: string;
  linkUrl: string;
}

// Интерфейс для изображения
export interface INotificationImage {
  src: string;
  alt: string;
  width?: number;
  height?: number;
}

// Интерфейс для инпута фидбека
export interface INotificationFeedbackInput {
  placeholder: string;
  submitButtonText: string;
  maxLength?: number;
}

// Основной интерфейс контента уведомления
export interface INotificationContent {
  type: ENotificationContentType;
  text?: string; // для обычного текста
  subtitleWithLink?: INotificationSubtitleWithLink; // для подзаголовка с ссылкой
  image?: INotificationImage; // для изображения
  feedbackInput?: INotificationFeedbackInput; // для инпута фидбека
}

// Интерфейс тега
export interface INotificationTag {
  id: string;
  text: string;
  color?: string; // цвет тега (hex, rgb или название цвета)
  backgroundColor?: string; // цвет фона тега
}

// Обновленный интерфейс уведомления
export interface INotification {
  id: string;
  type: ENotificationType;
  title: string;
  tags: INotificationTag[];
  content: string;
  createdAt: Date; // дата и время создания
  isRead: boolean;
}

// Интерфейс группы уведомлений
export type INotificationGroups = Record<ENotificationTab, INotification[]>;
